import { schemes, zSchema } from "@zeal/common";

export const updateCompanyTaxParameterRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  employeeID: schemes.mongoObjectId(),
  parameter: zSchema.object({
    code: zSchema.string(),
    value: zSchema.string(),
    effectiveDate: zSchema.string(),
  }),
});

export type TUpdateCompanyTaxParameterRequestSchema = zSchema.infer<
  typeof updateCompanyTaxParameterRequestSchema
>;

export const updateCompanyTaxParameterResponseSchema = zSchema.object({
  success: zSchema.boolean(),
});

export type TUpdateCompanyTaxParameterResponseSchema = zSchema.infer<
  typeof updateCompanyTaxParameterResponseSchema
>;
